import { render, staticRenderFns } from "./UserColorants.vue?vue&type=template&id=40dc3eda&scoped=true&"
import script from "./UserColorants.vue?vue&type=script&lang=js&"
export * from "./UserColorants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc3eda",
  null
  
)

export default component.exports